import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { pronunciationKeys } from './pronunciationKeys';
import { IPronunciation } from './useQueryPronunciations';

export interface ICreatePronunciationParams {
  text: string;
  audioS3Url: string;
}

export const createPronunciation = async (
  body: ICreatePronunciationParams
): Promise<IPronunciation> => {
  const response = await EXPRESS_API.post(`/customer-phonetics`, body);
  return response.data;
};

export const useCreatePronunciationMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(createPronunciation, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(pronunciationKeys.all());
      onSuccess?.();
      successToast({
        title: `Pronunciation has been successfully created!`,
      });
    },
    onError: error =>
      showError(
        error || `An error occurred while trying to create the pronunciation.`
      ),
  });
};
